//React
import React from 'react';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';

//Action
import * as myPhotoAction from '../action/myPhotoAction';

import Slide from '@material-ui/core/Slide';
//Icon
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      photoSubList: [],
  	}
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.open === false && this.props.open === true) {
      let list = Object.assign([], this.props.my.photo.sub);
      this.setState({photoSubList: list});
    }
  }

  _submit() {
    this.props.myPhotoSort(this.state.photoSubList, () => {
      this.props.close();
    })
  }

  _renderImgList = (value, index, array) => {
    return (
      <div
        key={index}
        className='box_outer'
        style={{margin:'2px'}}
      >
        <div
          className='box_inner'
        >
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'center',
            }}
          >
            <div style={{padding:'15px'}}>
              { (index + 1) }
            </div>
            <div style={{position:'relative'}}>
              <img
      					src={ value.uriCrop }
                style={{ width:'160px', height:'160px'}}
                alt=''
      				/>
              {
                (value.secret === 1) && (
                  <div
                    style={{
                      position:'absolute',
                      bottom:5,
                      right:5,
                    }}
                  >
                    <span className='black_icon' style={{fontSize:'0.8em'}}>シークレット</span>
        					</div>
                )
              }
            </div>
            <div style={{padding:'10px'}}>
              <div
                style={{
                  display:'flex',
                  flexFlow: 'column',
                  alignItems:'space-around',
                }}
              >
                <div style={{flex:1}}>
                {
                  (index !== 0) && (
                    <IconButton
                      onClick={ () => {
                        this._upDawn(index, 'up');
                      }}
                    >
                      <KeyboardArrowUpIcon style={{fontSize:'1.4em'}} />
                    </IconButton>
                  )
                }
                </div>
                <div style={{flex:1}}>
                {
                  (index !== (array.length - 1)) && (
                    <IconButton
                      onClick={ () => {
                        this._upDawn(index, 'down');
                      }}
                    >
                      <KeyboardArrowDownIcon style={{fontSize:'1.4em'}} />
                    </IconButton>
                  )
                }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
	}

  _upDawn(index, upDown) {
    let newList = this.state.photoSubList;
    if (upDown === 'up') {
      const remove = newList.splice(index, 1);
      newList.splice((index - 1), 0, remove[0]);
    }
    else if (upDown === 'down') {
      const remove = newList.splice(index, 1);
      newList.splice((index + 1), 0, remove[0]);
    }
    this.setState({photoSubList: newList});
  }

	render() {
  		return (
  			<Dialog
          fullScreen
          open={this.props.open}
          onClose={ () => this.props.close() }
          TransitionComponent={Transition}
          style={{maxWidth:'600px', margin:'auto'}}
        >
          <div style={{position:'fixed',top:'0',left:'0px',width:'100%' ,zIndex:'101'}}>
            <div style={{maxWidth:'600px', margin:'auto', background:'#FFF'}} className='shadow'>
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent:'space-between',
                }}
              >
                <div>
                  <IconButton
                    onClick={ () => {
                      this.props.close();
                    }}
                  >
                    <ArrowBackIosIcon />
                  </IconButton>
                  <span style={{fontSize:'1.1em',fontWeight:'bold'}}>写真の順番</span>
                </div>
              </div>
            </div>
          </div>
          <div style={{padding:'60px 15px 15px 15px',}}>
            <h4 align='center'>
              矢印を押して順番を変更してください
            </h4>
            <div style={{padding:'10px'}}>
              {
                (this.state.photoSubList.length > 0) && (
                  this.state.photoSubList.map((value, index, array) =>
      							this._renderImgList(value, index, array)
      						)
                )
    					}
            </div>
          </div>

          <div style={{position:'fixed',bottom:'0',left:'0px',width:'100%' ,zIndex:'101'}}>
            <div style={{maxWidth:'600px', margin:'auto', background:'rgba(0,0,0,0.3)'}}>
              <div style={{padding:'10px'}}>
                <Button
                  variant="contained"
                  color='primary'
                  onClick={ () => this._submit() }
                  style={{width: '100%', fontSize:'1.2em'}}
                  disabled={(JSON.stringify(this.state.photoSubList) === JSON.stringify(this.props.my.photo.sub)) ? true : false}
                >
                  保存する
                </Button>
              </div>
            </div>
          </div>

  			</Dialog>
      )

	}
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myPhotoAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
